export default __webpack_public_path__ + "static/media/pixellab--og--imprint.62f67b06.jpg";